import * as React from 'react'
import './styles.css'
import TrademarkText from '../../ui/TrademarkText'
import {
  ShieldCheckIcon,
  EyeIcon,
  DocumentMagnifyingGlassIcon,
  LockClosedIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline'
import { ReactComponent as AlgorithmicIcon } from '../../../assets/imgs/ai/algorithmic_intelligence.svg'
import { ReactComponent as FrontierIcon } from '../../../assets/imgs/ai/frontier_icon.svg'
import { ReactComponent as PrivateIcon } from '../../../assets/imgs/ai/private_icon.svg'

const GOVERNANCE_ITEMS = [
  { label: 'Human Oversight', Icon: EyeIcon },
  { label: 'Transparency & Explainability', Icon: ShieldCheckIcon },
  { label: 'Auditability & Traceability', Icon: DocumentMagnifyingGlassIcon },
  { label: 'Data Protection & Security', Icon: LockClosedIcon },
  { label: 'Risk Assessment & Management', Icon: ExclamationTriangleIcon },
]

const EXECUTION_CARDS = [
  {
    title: 'Algorithmic Intelligence (Core Mode)',
    body: 'Deterministic, explainable, and fully auditable analytics used for skills extraction, matching, scoring, graph analysis, and optimisation. Does not rely on LLMs. Maximum transparency and reproducibility.',
    Icon: AlgorithmicIcon,
  },
  {
    title: 'Frontier Large Language Models (Optional & Governed)',
    body: 'Policy-controlled access to external language models for summarisation, natural language interaction, and assisted analysis. Human oversight and governance controls ensure alignment with organisational policies.',
    Icon: FrontierIcon,
  },
  {
    title: 'Private / Sovereign AI Deployment',
    body: 'Optional deployment of AI models in private cloud or on-premise environments with no data egress and full organisational control. Supports sovereign, secure, and mission-critical deployments.',
    Icon: PrivateIcon,
  },
]

const SovereignIntelligence = () => {
  return (
    <section className='overview-section sovereign-intelligence-section'>
      <div className='box'>
        <h2 className='sovereign-intelligence-title'>
          Turn AI Into Controlled, Sovereign Intelligence
        </h2>

        <p className='sovereign-intelligence-copy'>
          <TrademarkText>Pod Adaptive Intelligence Engine™</TrademarkText>{' '}
          combines proprietary algorithms, secure AI model integration, and
          sovereign deployment capabilities to deliver explainable, auditable,
          and secure workforce intelligence for enterprise and government
          environments.
        </p>

        <p className='sovereign-intelligence-copy'>
          All intelligence layers are orchestrated through{' '}
          <TrademarkText>Pod Intelligence Core™</TrademarkText>, ensuring
          transparency, control, and compliance across enterprise, defense, and
          public sector deployments.
        </p>

        <div className='sovereign-governance-list'>
          <div className='sovereign-governance-track'>
            {GOVERNANCE_ITEMS.map(({ label, Icon }) => (
              <div key={label} className='sovereign-governance-item'>
                <Icon className='sovereign-governance-icon' />
                <span>{label}</span>
              </div>
            ))}
            {GOVERNANCE_ITEMS.map(({ label, Icon }) => (
              <div key={`${label}-duplicate`} className='sovereign-governance-item' aria-hidden='true'>
                <Icon className='sovereign-governance-icon' />
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className='sovereign-execution-grid'>
          {EXECUTION_CARDS.map(({ title, body, Icon }, index) => (
            <article key={`execution-${title}`} className='sovereign-option-card'>
              <div className='sovereign-option-head'>
                <span className='sovereign-option-index'>{`0${index + 1}`}</span>
                <Icon className='sovereign-option-icon' />
              </div>
              <h3>{title}</h3>
              <p>{body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default SovereignIntelligence
